import React, { useState, useEffect } from 'react';
import { PRESS as FALLBACK_PRESS, HERO_TILES as FALLBACK_HERO_TILES, FAQS as FALLBACK_FAQS, DIAMOND_SECTION_VIDEO } from '../mock';
import { Link } from 'react-router-dom';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

export const PressLogos = () => {
  const pressList = FALLBACK_PRESS;

  const list = [...pressList, ...pressList];
  return (
    <section className="py-10 bg-[#FFFFFF]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 text-center mb-10">
        <h2 className="font-serif text-3xl lg:text-4xl text-[#1a1a1a]">As Seen In</h2>
      </div>
      <div className="overflow-hidden">
        <div className="flex gap-16 animate-marquee whitespace-nowrap">
          {list.map((p, i) => (
            <div key={i} className="font-serif text-2xl lg:text-3xl text-[#7a6a54] flex-shrink-0 opacity-70 hover:opacity-100 transition-opacity">{p}</div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const DualTiles = () => {
  const tiles = FALLBACK_HERO_TILES;

  return (
    <section className="py-10 bg-[#FFFFFF]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-6">
        {tiles.map((t, i) => (
          <Link key={i} to={t.href} className="group relative overflow-hidden aspect-[5/4] block">
            <img src={t.image} alt={t.title} className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-black/10" />
            <div className="absolute inset-x-0 bottom-10 text-center text-white px-4">
              <h3 className="font-serif text-3xl lg:text-4xl whitespace-pre-line leading-tight">{t.title}</h3>
              <div className="mt-6 inline-block text-[11px] tracking-widest-2 uppercase border-b border-white/80 pb-1">{t.cta}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export const LabDiamondsBlock = () => {
  const heading = 'Diamonds that don’t cost the Earth';
  const body = 'Grown under conditions that mirror the earth’s. Chemically, physically, and optically identical to mined diamonds — but kinder to the planet and priced more sensibly.';
  const video = DIAMOND_SECTION_VIDEO;

  return (
    <section className="lg:py-12 bg-[#FFFFFF]">
      <div className="lg:hidden">
        <div className="relative w-full diamond-vh-mobile overflow-hidden bg-[#1a1a1a]">
          <video
            src={video}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        </div>
        <div className="px-6 py-10 text-center bg-[#FFFFFF]">
          <h2 className="font-serif text-3xl text-[#1a1a1a] leading-tight">
            {heading}
          </h2>
          <p className="mt-4 text-[14px] text-[#5a5346] leading-relaxed max-w-md mx-auto">
            {body}
          </p>
          <Link to="/pages/diamond-education" className="btn-cta mt-6">Read More</Link>
        </div>
      </div>

      <div className="hidden lg:grid max-w-[1500px] mx-auto px-6 lg:px-10 lg:grid-cols-[1.3fr_1fr] gap-12 lg:gap-16 items-center">
        <div className="aspect-square bg-[#FFFFFF] overflow-hidden flex items-center justify-center">
          <img src="https://houseofquadri.com/cdn/shop/files/oval_diamond.webp?width=800" alt="Oval Diamond" className="w-full h-full object-contain" />
        </div>
        <div>
          <h2 className="font-serif text-4xl lg:text-6xl leading-tight text-[#1a1a1a]">
            {heading}
          </h2>
          <p className="mt-6 text-[15px] text-[#5a5346] leading-relaxed max-w-xl">
            {body}
          </p>
          <Link to="/pages/diamond-education" className="btn-cta mt-8">Read More</Link>
        </div>
      </div>
    </section>
  );
};

export const FaqSection = () => {
  const faqs = FALLBACK_FAQS;

  const groups = faqs.reduce((acc, f) => {
    (acc[f.group] = acc[f.group] || []).push(f);
    return acc;
  }, {});

  return (
    <section className="py-14 lg:py-20 bg-[#FFFFFF]">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 text-left">
        <div className="mb-12 lg:mb-16">
          <h2 className="font-serif text-2xl lg:text-3xl text-left text-[#1a1a1a]">Frequently Asked Questions</h2>
        </div>
        <div className="space-y-10 lg:space-y-14">
          {Object.entries(groups).map(([group, items]) => (
            <div key={group}>
              <h3 className="text-left text-[12px] tracking-widest-2 uppercase text-[#7a6a54] mb-4">{group}</h3>
              <Accordion type="single" collapsible className="w-full">
                {items.map((f, i) => (
                  <AccordionItem key={i} value={`${group}-${i}`} className="border-b border-[#d8ceb9]">
                    <AccordionTrigger className="font-serif text-[13px] lg:text-sm text-left text-[#1a1a1a] py-4 lg:py-5 hover:no-underline">{f.q}</AccordionTrigger>
                    <AccordionContent className="text-[12px] text-[#5a5346] leading-relaxed text-left pb-4 lg:pb-5">{f.a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

